import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// --- Token helpers (Bearer auth) -------------------------------------------
// We store the access_token in localStorage and inject it as a Bearer header
// on every request. This is more robust across cross-origin / proxy setups
// than relying purely on Set-Cookie (which some production proxies strip).
// The catch blocks ignore SecurityError thrown when localStorage is disabled
// (private mode / cross-origin iframe) — there's nothing useful to do there.
const TOKEN_KEY = "tnm_access_token";
const safe = (fn, fallback) => {
  try { return fn(); }
  catch (err) { if (typeof console !== "undefined") console.warn("[api] storage unavailable:", err?.name || err); return fallback; }
};
export const tokenStore = {
  get: () => safe(() => localStorage.getItem(TOKEN_KEY) || "", ""),
  set: (t) => safe(() => { if (t) localStorage.setItem(TOKEN_KEY, t); }, undefined),
  clear: () => safe(() => localStorage.removeItem(TOKEN_KEY), undefined),
};

export const api = axios.create({
  baseURL: API,
  timeout: 120000,
  withCredentials: true, // keep cookie fallback for environments that allow it
});

// Attach Bearer token on every request when we have one
api.interceptors.request.use((cfg) => {
  const t = tokenStore.get();
  if (t) cfg.headers = { ...(cfg.headers || {}), Authorization: `Bearer ${t}` };
  return cfg;
});

// On 401, redirect to admin login if currently in admin area
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && typeof window !== "undefined") {
      // Token is stale — drop it so we don't loop
      tokenStore.clear();
      if (window.location.pathname.startsWith("/admin") && !window.location.pathname.endsWith("/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_maintenance-master-8/artifacts/lvqicc5n_White%20Logo.png";
export const BRAND = {
  name: "True North Maintenance",
  tagline: "Reliable maintenance, repairs & cleaning — done right the first time.",
  phone: "0478 350 778",
  email: "blake@truenorthmaintenance.com.au",
  area: "Albury / Wodonga & surrounds",
  socials: {
    google: "https://share.google/Nl3EvWBtfEPpcNXe4",
    facebook: "https://www.facebook.com/p/True-North-Maintenance-61579309812737/",
    instagram: "https://www.instagram.com/true_north_maintenance/",
    write_review: "https://g.page/r/CQfZ2Pmh7x-4EAE/review",
  },
};
